// ============================================================================
// TREAP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'treap',
  name: 'Treap',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) expected per operation',
    space: 'O(N)'
  },
  description: 'A randomized binary search tree that combines BST properties with heap properties using random priorities. Provides expected O(log N) time for operations and is simpler to implement than deterministic balanced trees.'
};
